import type { LanguageIsoCodeEnum } from "@core/domain/models/language.model";
import { toLanguageIsoCode } from "@core/domain/models/language.model";
import type { LanguageRepository } from "@core/domain/repositories/language.repository";
import { coreTypes } from "@core/root/core-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class LanguageGetCurrentUseCase {
    constructor(
        @inject(coreTypes.repositories.LanguageRepository)
        private readonly languageRepository: LanguageRepository,
    ) {}

    execute(): LanguageIsoCodeEnum {
        const defaultLanguage = this.languageRepository.getDefault();

        return this.languageRepository.getCurrent().match(
            (currentLanguage) =>
                toLanguageIsoCode(currentLanguage, defaultLanguage),
            () => defaultLanguage,
        );
    }
}
